<template>
    <div class="mehrwertige-alkohole">
        <p>
            Alkohole mit mehreren OH-Gruppen
        </p>
    </div>
</template>

<script>
export default {
    name: 'mehrwertige-alkohole',
};
</script>
